var path = '/app/components/ui/countdown/countdown.html';
var html = "<div id=countdown>{{ $ctrl.countdown || $ctrl.minutes + \":00\" }}</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/countdown/countdown.html
// module id = 232
// module chunks = 0